// Geographic center coordinates for countries (ISO 3166-1 alpha-2 and alpha-3)
export const COUNTRY_CENTERS: Record<string, { lat: number; lng: number }> = {
  // North America
  US: { lat: 39.8, lng: -98.5 }, USA: { lat: 39.8, lng: -98.5 },
  CA: { lat: 56.1, lng: -106.3 }, CAN: { lat: 56.1, lng: -106.3 },
  MX: { lat: 23.6, lng: -102.5 }, MEX: { lat: 23.6, lng: -102.5 },

  // Central America & Caribbean
  GT: { lat: 15.8, lng: -90.2 }, GTM: { lat: 15.8, lng: -90.2 },
  BZ: { lat: 17.2, lng: -88.5 }, BLZ: { lat: 17.2, lng: -88.5 },
  HN: { lat: 15.2, lng: -86.2 }, HND: { lat: 15.2, lng: -86.2 },
  SV: { lat: 13.8, lng: -88.9 }, SLV: { lat: 13.8, lng: -88.9 },
  NI: { lat: 12.9, lng: -85.2 }, NIC: { lat: 12.9, lng: -85.2 },
  CR: { lat: 10.0, lng: -84.2 }, CRI: { lat: 10.0, lng: -84.2 },
  PA: { lat: 8.5, lng: -80.8 }, PAN: { lat: 8.5, lng: -80.8 },
  CU: { lat: 21.5, lng: -77.8 }, CUB: { lat: 21.5, lng: -77.8 },
  JM: { lat: 18.1, lng: -77.3 }, JAM: { lat: 18.1, lng: -77.3 },
  DO: { lat: 18.7, lng: -70.2 }, DOM: { lat: 18.7, lng: -70.2 },
  PR: { lat: 18.2, lng: -66.6 }, PRI: { lat: 18.2, lng: -66.6 },
  TT: { lat: 10.7, lng: -61.2 }, TTO: { lat: 10.7, lng: -61.2 },
  BS: { lat: 25.0, lng: -77.4 }, BHS: { lat: 25.0, lng: -77.4 },
  BB: { lat: 13.2, lng: -59.5 }, BRB: { lat: 13.2, lng: -59.5 },
  AG: { lat: 17.1, lng: -61.8 }, ATG: { lat: 17.1, lng: -61.8 },
  DM: { lat: 15.4, lng: -61.4 }, DMA: { lat: 15.4, lng: -61.4 },
  GD: { lat: 12.1, lng: -61.7 }, GRD: { lat: 12.1, lng: -61.7 },
  KN: { lat: 17.3, lng: -62.7 }, KNA: { lat: 17.3, lng: -62.7 },
  LC: { lat: 13.9, lng: -61.0 }, LCA: { lat: 13.9, lng: -61.0 },
  VC: { lat: 13.3, lng: -61.2 }, VCT: { lat: 13.3, lng: -61.2 },
  AI: { lat: 18.2, lng: -63.1 }, AIA: { lat: 18.2, lng: -63.1 },
  BM: { lat: 32.3, lng: -64.8 }, BMU: { lat: 32.3, lng: -64.8 },
  VG: { lat: 18.4, lng: -64.6 }, VGB: { lat: 18.4, lng: -64.6 },
  KY: { lat: 19.5, lng: -80.6 }, CYM: { lat: 19.5, lng: -80.6 },
  MS: { lat: 16.7, lng: -62.2 }, MSR: { lat: 16.7, lng: -62.2 },
  TC: { lat: 21.7, lng: -71.8 }, TCA: { lat: 21.7, lng: -71.8 },

  // South America
  BR: { lat: -14.2, lng: -51.9 }, BRA: { lat: -14.2, lng: -51.9 },
  AR: { lat: -38.4, lng: -63.6 }, ARG: { lat: -38.4, lng: -63.6 },
  CL: { lat: -35.7, lng: -71.5 }, CHL: { lat: -35.7, lng: -71.5 },
  CO: { lat: 4.6, lng: -74.3 }, COL: { lat: 4.6, lng: -74.3 },
  VE: { lat: 6.4, lng: -66.6 }, VEN: { lat: 6.4, lng: -66.6 },
  PE: { lat: -9.2, lng: -75.0 }, PER: { lat: -9.2, lng: -75.0 },
  EC: { lat: -1.8, lng: -78.2 }, ECU: { lat: -1.8, lng: -78.2 },
  BO: { lat: -16.3, lng: -63.6 }, BOL: { lat: -16.3, lng: -63.6 },
  PY: { lat: -23.4, lng: -58.4 }, PRY: { lat: -23.4, lng: -58.4 },
  UY: { lat: -32.5, lng: -55.8 }, URY: { lat: -32.5, lng: -55.8 },
  GY: { lat: 5.0, lng: -59.0 }, GUY: { lat: 5.0, lng: -59.0 },
  SR: { lat: 3.9, lng: -56.0 }, SUR: { lat: 3.9, lng: -56.0 },

  // Western Europe
  GB: { lat: 55.4, lng: -3.4 }, GBR: { lat: 55.4, lng: -3.4 },
  FR: { lat: 46.2, lng: 2.2 }, FRA: { lat: 46.2, lng: 2.2 },
  DE: { lat: 51.2, lng: 10.4 }, DEU: { lat: 51.2, lng: 10.4 },
  IT: { lat: 41.9, lng: 12.6 }, ITA: { lat: 41.9, lng: 12.6 },
  ES: { lat: 40.5, lng: -3.7 }, ESP: { lat: 40.5, lng: -3.7 },
  PT: { lat: 39.4, lng: -8.2 }, PRT: { lat: 39.4, lng: -8.2 },
  NL: { lat: 52.1, lng: 5.3 }, NLD: { lat: 52.1, lng: 5.3 },
  BE: { lat: 50.5, lng: 4.5 }, BEL: { lat: 50.5, lng: 4.5 },
  LU: { lat: 49.8, lng: 6.1 }, LUX: { lat: 49.8, lng: 6.1 },
  CH: { lat: 46.8, lng: 8.2 }, CHE: { lat: 46.8, lng: 8.2 },
  AT: { lat: 47.5, lng: 14.6 }, AUT: { lat: 47.5, lng: 14.6 },
  IE: { lat: 53.1, lng: -7.7 }, IRL: { lat: 53.1, lng: -7.7 },

  // Northern Europe
  SE: { lat: 60.1, lng: 18.6 }, SWE: { lat: 60.1, lng: 18.6 },
  NO: { lat: 60.5, lng: 8.5 }, NOR: { lat: 60.5, lng: 8.5 },
  DK: { lat: 56.3, lng: 9.5 }, DNK: { lat: 56.3, lng: 9.5 },
  FI: { lat: 61.9, lng: 25.7 }, FIN: { lat: 61.9, lng: 25.7 },
  IS: { lat: 64.9, lng: -19.0 }, ISL: { lat: 64.9, lng: -19.0 },

  // Eastern Europe
  PL: { lat: 51.9, lng: 19.1 }, POL: { lat: 51.9, lng: 19.1 },
  CZ: { lat: 49.8, lng: 15.5 }, CZE: { lat: 49.8, lng: 15.5 },
  SK: { lat: 48.7, lng: 19.7 }, SVK: { lat: 48.7, lng: 19.7 },
  HU: { lat: 47.2, lng: 19.5 }, HUN: { lat: 47.2, lng: 19.5 },
  RO: { lat: 45.9, lng: 25.0 }, ROU: { lat: 45.9, lng: 25.0 },
  BG: { lat: 42.7, lng: 25.5 }, BGR: { lat: 42.7, lng: 25.5 },
  HR: { lat: 45.1, lng: 15.2 }, HRV: { lat: 45.1, lng: 15.2 },
  SI: { lat: 46.2, lng: 15.0 }, SVN: { lat: 46.2, lng: 15.0 },
  RS: { lat: 44.0, lng: 21.0 }, SRB: { lat: 44.0, lng: 21.0 },
  BA: { lat: 43.9, lng: 17.7 }, BIH: { lat: 43.9, lng: 17.7 },
  ME: { lat: 42.7, lng: 19.4 }, MNE: { lat: 42.7, lng: 19.4 },
  MK: { lat: 41.5, lng: 21.7 }, MKD: { lat: 41.5, lng: 21.7 },
  AL: { lat: 41.2, lng: 20.2 }, ALB: { lat: 41.2, lng: 20.2 },
  XK: { lat: 42.6, lng: 20.9 }, XKX: { lat: 42.6, lng: 20.9 }, XKK: { lat: 42.6, lng: 20.9 },
  MD: { lat: 47.4, lng: 28.4 }, MDA: { lat: 47.4, lng: 28.4 },

  // Baltic States
  EE: { lat: 58.6, lng: 25.0 }, EST: { lat: 58.6, lng: 25.0 },
  LV: { lat: 56.9, lng: 24.1 }, LVA: { lat: 56.9, lng: 24.1 },
  LT: { lat: 55.2, lng: 23.9 }, LTU: { lat: 55.2, lng: 23.9 },

  // Eastern Europe / CIS
  RU: { lat: 61.5, lng: 105.3 }, RUS: { lat: 61.5, lng: 105.3 },
  UA: { lat: 48.4, lng: 31.2 }, UKR: { lat: 48.4, lng: 31.2 },
  BY: { lat: 53.7, lng: 27.9 }, BLR: { lat: 53.7, lng: 27.9 },
  GE: { lat: 42.3, lng: 43.4 }, GEO: { lat: 42.3, lng: 43.4 },
  AM: { lat: 40.1, lng: 45.0 }, ARM: { lat: 40.1, lng: 45.0 },
  AZ: { lat: 40.1, lng: 47.6 }, AZE: { lat: 40.1, lng: 47.6 },

  // Mediterranean
  GR: { lat: 39.1, lng: 21.8 }, GRC: { lat: 39.1, lng: 21.8 },
  CY: { lat: 35.1, lng: 33.4 }, CYP: { lat: 35.1, lng: 33.4 },
  MT: { lat: 35.9, lng: 14.4 }, MLT: { lat: 35.9, lng: 14.4 },
  TR: { lat: 39.0, lng: 35.2 }, TUR: { lat: 39.0, lng: 35.2 },

  // Middle East
  IL: { lat: 31.0, lng: 34.9 }, ISR: { lat: 31.0, lng: 34.9 },
  SA: { lat: 23.9, lng: 45.1 }, SAU: { lat: 23.9, lng: 45.1 },
  AE: { lat: 23.4, lng: 53.8 }, ARE: { lat: 23.4, lng: 53.8 },
  QA: { lat: 25.4, lng: 51.2 }, QAT: { lat: 25.4, lng: 51.2 },
  KW: { lat: 29.3, lng: 47.5 }, KWT: { lat: 29.3, lng: 47.5 },
  BH: { lat: 26.1, lng: 50.6 }, BHR: { lat: 26.1, lng: 50.6 },
  OM: { lat: 21.5, lng: 55.9 }, OMN: { lat: 21.5, lng: 55.9 },
  JO: { lat: 30.6, lng: 36.2 }, JOR: { lat: 30.6, lng: 36.2 },
  LB: { lat: 33.9, lng: 35.9 }, LBN: { lat: 33.9, lng: 35.9 },
  IQ: { lat: 33.2, lng: 43.7 }, IRQ: { lat: 33.2, lng: 43.7 },
  YE: { lat: 15.6, lng: 48.5 }, YEM: { lat: 15.6, lng: 48.5 },

  // North Africa
  EG: { lat: 26.8, lng: 30.8 }, EGY: { lat: 26.8, lng: 30.8 },
  LY: { lat: 26.3, lng: 17.2 }, LBY: { lat: 26.3, lng: 17.2 },
  TN: { lat: 33.9, lng: 9.5 }, TUN: { lat: 33.9, lng: 9.5 },
  DZ: { lat: 28.0, lng: 1.7 }, DZA: { lat: 28.0, lng: 1.7 },
  MA: { lat: 31.8, lng: -7.1 }, MAR: { lat: 31.8, lng: -7.1 },

  // Sub-Saharan Africa
  NG: { lat: 9.1, lng: 8.7 }, NGA: { lat: 9.1, lng: 8.7 },
  GH: { lat: 7.9, lng: -1.0 }, GHA: { lat: 7.9, lng: -1.0 },
  KE: { lat: -0.0, lng: 37.9 }, KEN: { lat: -0.0, lng: 37.9 },
  ZA: { lat: -30.6, lng: 22.9 }, ZAF: { lat: -30.6, lng: 22.9 },
  ET: { lat: 9.1, lng: 40.5 }, ETH: { lat: 9.1, lng: 40.5 },
  TZ: { lat: -6.4, lng: 34.9 }, TZA: { lat: -6.4, lng: 34.9 },
  UG: { lat: 1.4, lng: 32.3 }, UGA: { lat: 1.4, lng: 32.3 },
  CM: { lat: 7.4, lng: 12.4 }, CMR: { lat: 7.4, lng: 12.4 },
  CI: { lat: 7.5, lng: -5.5 }, CIV: { lat: 7.5, lng: -5.5 },
  SN: { lat: 14.5, lng: -14.5 }, SEN: { lat: 14.5, lng: -14.5 },
  MG: { lat: -18.8, lng: 46.9 }, MDG: { lat: -18.8, lng: 46.9 },
  AO: { lat: -11.2, lng: 17.9 }, AGO: { lat: -11.2, lng: 17.9 },
  MZ: { lat: -18.7, lng: 35.5 }, MOZ: { lat: -18.7, lng: 35.5 },
  ZM: { lat: -13.1, lng: 27.8 }, ZMB: { lat: -13.1, lng: 27.8 },
  ZW: { lat: -19.0, lng: 29.2 }, ZWE: { lat: -19.0, lng: 29.2 },
  BW: { lat: -22.3, lng: 24.7 }, BWA: { lat: -22.3, lng: 24.7 },
  NA: { lat: -22.6, lng: 18.5 }, NAM: { lat: -22.6, lng: 18.5 },
  RW: { lat: -1.9, lng: 29.9 }, RWA: { lat: -1.9, lng: 29.9 },
  ML: { lat: 17.6, lng: -4.0 }, MLI: { lat: 17.6, lng: -4.0 },
  BF: { lat: 12.2, lng: -1.6 }, BFA: { lat: 12.2, lng: -1.6 },
  NE: { lat: 17.6, lng: 8.1 }, NER: { lat: 17.6, lng: 8.1 },
  TD: { lat: 15.5, lng: 18.7 }, TCD: { lat: 15.5, lng: 18.7 },
  CD: { lat: -4.0, lng: 21.8 }, COD: { lat: -4.0, lng: 21.8 },
  CG: { lat: -0.2, lng: 15.8 }, COG: { lat: -0.2, lng: 15.8 },
  GA: { lat: -0.8, lng: 11.6 }, GAB: { lat: -0.8, lng: 11.6 },
  BJ: { lat: 9.3, lng: 2.3 }, BEN: { lat: 9.3, lng: 2.3 },
  SL: { lat: 8.5, lng: -11.8 }, SLE: { lat: 8.5, lng: -11.8 },
  LR: { lat: 6.4, lng: -9.4 }, LBR: { lat: 6.4, lng: -9.4 },
  GW: { lat: 11.8, lng: -15.2 }, GNB: { lat: 11.8, lng: -15.2 },
  GM: { lat: 13.4, lng: -15.3 }, GMB: { lat: 13.4, lng: -15.3 },
  MR: { lat: 21.0, lng: -10.9 }, MRT: { lat: 21.0, lng: -10.9 },
  MW: { lat: -13.3, lng: 34.3 }, MWI: { lat: -13.3, lng: 34.3 },
  SZ: { lat: -26.5, lng: 31.5 }, SWZ: { lat: -26.5, lng: 31.5 },
  CV: { lat: 16.0, lng: -24.0 }, CPV: { lat: 16.0, lng: -24.0 },
  MU: { lat: -20.3, lng: 57.6 }, MUS: { lat: -20.3, lng: 57.6 },
  SC: { lat: -4.7, lng: 55.5 }, SYC: { lat: -4.7, lng: 55.5 },
  ST: { lat: 0.2, lng: 6.6 }, STP: { lat: 0.2, lng: 6.6 },
  SD: { lat: 12.9, lng: 30.2 }, SDN: { lat: 12.9, lng: 30.2 },

  // South Asia
  IN: { lat: 20.6, lng: 79.0 }, IND: { lat: 20.6, lng: 79.0 },
  PK: { lat: 30.4, lng: 69.3 }, PAK: { lat: 30.4, lng: 69.3 },
  BD: { lat: 23.7, lng: 90.4 }, BGD: { lat: 23.7, lng: 90.4 },
  LK: { lat: 7.9, lng: 80.8 }, LKA: { lat: 7.9, lng: 80.8 },
  NP: { lat: 28.4, lng: 84.1 }, NPL: { lat: 28.4, lng: 84.1 },
  BT: { lat: 27.5, lng: 90.4 }, BTN: { lat: 27.5, lng: 90.4 },
  MV: { lat: 3.2, lng: 73.2 }, MDV: { lat: 3.2, lng: 73.2 },
  AF: { lat: 33.9, lng: 67.7 }, AFG: { lat: 33.9, lng: 67.7 },

  // East Asia
  CN: { lat: 35.9, lng: 104.2 }, CHN: { lat: 35.9, lng: 104.2 },
  JP: { lat: 36.2, lng: 138.3 }, JPN: { lat: 36.2, lng: 138.3 },
  KR: { lat: 35.9, lng: 127.8 }, KOR: { lat: 35.9, lng: 127.8 },
  TW: { lat: 23.7, lng: 121.0 }, TWN: { lat: 23.7, lng: 121.0 },
  MN: { lat: 46.9, lng: 103.8 }, MNG: { lat: 46.9, lng: 103.8 },
  HK: { lat: 22.4, lng: 114.1 }, HKG: { lat: 22.4, lng: 114.1 },
  MO: { lat: 22.2, lng: 113.5 }, MAC: { lat: 22.2, lng: 113.5 },

  // Southeast Asia
  TH: { lat: 15.9, lng: 100.9 }, THA: { lat: 15.9, lng: 100.9 },
  VN: { lat: 14.1, lng: 108.3 }, VNM: { lat: 14.1, lng: 108.3 },
  PH: { lat: 12.9, lng: 121.8 }, PHL: { lat: 12.9, lng: 121.8 },
  MY: { lat: 4.2, lng: 101.9 }, MYS: { lat: 4.2, lng: 101.9 },
  SG: { lat: 1.4, lng: 103.8 }, SGP: { lat: 1.4, lng: 103.8 },
  ID: { lat: -0.8, lng: 113.9 }, IDN: { lat: -0.8, lng: 113.9 },
  MM: { lat: 21.9, lng: 96.0 }, MMR: { lat: 21.9, lng: 96.0 },
  KH: { lat: 12.6, lng: 105.0 }, KHM: { lat: 12.6, lng: 105.0 },
  LA: { lat: 19.9, lng: 102.5 }, LAO: { lat: 19.9, lng: 102.5 },
  BN: { lat: 4.5, lng: 114.7 }, BRN: { lat: 4.5, lng: 114.7 },

  // Central Asia
  KZ: { lat: 48.0, lng: 68.0 }, KAZ: { lat: 48.0, lng: 68.0 },
  UZ: { lat: 41.4, lng: 64.6 }, UZB: { lat: 41.4, lng: 64.6 },
  TM: { lat: 39.0, lng: 59.6 }, TKM: { lat: 39.0, lng: 59.6 },
  TJ: { lat: 38.9, lng: 71.3 }, TJK: { lat: 38.9, lng: 71.3 },
  KG: { lat: 41.2, lng: 74.8 }, KGZ: { lat: 41.2, lng: 74.8 },

  // Oceania
  AU: { lat: -25.3, lng: 133.8 }, AUS: { lat: -25.3, lng: 133.8 },
  NZ: { lat: -40.9, lng: 174.9 }, NZL: { lat: -40.9, lng: 174.9 },
  PG: { lat: -6.3, lng: 143.9 }, PNG: { lat: -6.3, lng: 143.9 },
  FJ: { lat: -17.7, lng: 178.1 }, FJI: { lat: -17.7, lng: 178.1 },
  SB: { lat: -9.6, lng: 160.2 }, SLB: { lat: -9.6, lng: 160.2 },
  VU: { lat: -15.4, lng: 166.9 }, VUT: { lat: -15.4, lng: 166.9 },
  TO: { lat: -21.2, lng: -175.2 }, TON: { lat: -21.2, lng: -175.2 },
  NR: { lat: -0.5, lng: 166.9 }, NRU: { lat: -0.5, lng: 166.9 },
  PW: { lat: 7.5, lng: 134.6 }, PLW: { lat: 7.5, lng: 134.6 },
  FM: { lat: 7.4, lng: 150.6 }, FSM: { lat: 7.4, lng: 150.6 },
};
